import { useMutation } from "@apollo/client/react";

import { AiIntegration, MutationAiIntegrationUpdateArgs } from "types/generated";

import { UPDATE_AI_INTEGRATION } from "./gql";

type UseUpdateAiIntegrationOptions = Omit<
  useMutation.Options<
    { aiIntegrationUpdate: Pick<AiIntegration, "id"> },
    MutationAiIntegrationUpdateArgs
  >,
  "variables"
>;

const useUpdateAiIntegration = (options?: UseUpdateAiIntegrationOptions) => {
  return useMutation(UPDATE_AI_INTEGRATION, {
    awaitRefetchQueries: true,
    ...options,
  });
};

export default useUpdateAiIntegration;
